export class LoginModel {
  public email = '';
  public password = '';
}
